export const MOCK_TICKETS_RESPONSE = {
  data: {
    results: [
      {
        id: 'mock-ticket-1',
        title: 'SQL Injection on /api/login — Needs Immediate Fix',
        creator: 'alice@example.com',
        assigned_to: 'bob@example.com',
        description: 'Critical SQL injection found at the login endpoint. Attacker can bypass authentication.',
        status: 'open',
        priority: 'high',
        created_at: '2024-11-14T10:30:00Z',
        attachment: null,
        comments: [],
      },
      {
        id: 'mock-ticket-2',
        title: 'Outdated TLS on legacy subdomain',
        creator: 'alice@example.com',
        assigned_to: 'carol@example.com',
        description: 'legacy.example.com still accepts TLS 1.0. Needs upgrade to TLS 1.2+.',
        status: 'in_progress',
        priority: 'medium',
        created_at: '2024-11-13T09:00:00Z',
        attachment: null,
        comments: [],
      },
      {
        id: 'mock-ticket-3',
        title: 'Missing security headers on marketing site',
        creator: 'dave@example.com',
        assigned_to: null,
        description: 'X-Frame-Options and Content-Security-Policy headers are absent.',
        status: 'open',
        priority: 'low',
        created_at: '2024-11-12T14:45:00Z',
        attachment: null,
        comments: [],
      },
    ],
    current_page: 1,
    total_pages: 1,
  },
}

export const MOCK_TICKET_FILTER_OPTIONS = {
  status: [
    { name: 'open', count: 2 },
    { name: 'in_progress', count: 1 },
    { name: 'closed', count: 0 },
  ],
}

export const MOCK_TICKET_DETAIL = {
  id: 'mock-ticket-1',
  title: 'SQL Injection on /api/login — Needs Immediate Fix',
  creator: 'alice@example.com',
  assigned_to: 'bob@example.com',
  created_at: '2024-11-14T10:30:00Z',
  status: 'open',
  priority: 'high',
  description: 'Critical SQL injection found at the login endpoint. Attacker can bypass authentication by entering a payload like: `\' OR 1=1 --`. Recommend parameterised queries and WAF rule.',
  attachment: null,
  comments: [
    {
      author: 'bob@example.com',
      created_at: '2024-11-14T11:00:00Z',
      content: 'Confirmed. Assigned to dev team for patching in sprint 42.',
      attachment: null,
    },
  ],
}
